import { render, staticRenderFns } from "./overlay-footer.vue?vue&type=template&id=648d67d7&"
import script from "./overlay-footer.vue?vue&type=script&lang=js&"
export * from "./overlay-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports